"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFirebaseMessaging = void 0;
var tslib_1 = require("tslib");
var react_redux_1 = require("react-redux");
var getFirebaseMessagingToken_1 = require("../utilities/get/getFirebaseMessagingToken");
var sentrySdk_1 = require("../sdks/sentry/sentrySdk");
var SentrySeverity_1 = require("../sdks/sentry/SentrySeverity");
var react_1 = require("react");
var messaging_1 = require("firebase/messaging");
var useRemovePushTokens_1 = require("./useRemovePushTokens");
var react_redux_2 = require("react-redux");
var clientMeta_1 = require("../utilities/clientMeta");
var convertToPermissionState = function (permission) {
    if (permission === 'granted') {
        return 'granted';
    }
    if (permission === 'denied') {
        return 'denied';
    }
    return 'prompt';
};
var useFirebaseMessaging = function (_a) {
    var parentDescription = _a.parentDescription;
    var dispatch = (0, react_redux_1.useDispatch)();
    var description = "".concat(parentDescription, " - useFirebaseMessaging");
    var submitRemovePushToken = (0, useRemovePushTokens_1.useRemovePushTokens)({
        parentDescription: description,
    }).submitRemovePushToken;
    var firebaseMessagingToken = (0, react_redux_2.useSelector)(function (state) {
        var _a;
        return (_a = state.windowMeta) === null || _a === void 0 ? void 0 : _a.firebaseMessagingToken;
    });
    var setToken = (0, react_1.useCallback)(function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var permissionState, firebaseMessagingToken_1, error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof Notification !== 'undefined')) return [3 /*break*/, 5];
                    permissionState = convertToPermissionState(Notification.permission);
                    firebaseMessagingToken_1 = null;
                    if (!(permissionState === 'granted')) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, getFirebaseMessagingToken_1.getFirebaseMessagingToken)({
                            askForPermission: false,
                        })];
                case 2:
                    firebaseMessagingToken_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    // we dont want to dispatch createErrorAction since app can function fine
                    (0, sentrySdk_1.sentrySdk)().captureMessage("".concat(description, ": ").concat(JSON.stringify(error_1)), SentrySeverity_1.SentrySeverity.Critical);
                    return [3 /*break*/, 4];
                case 4:
                    dispatch({
                        type: 'SET_WINDOW_META',
                        values: {
                            firebaseMessagingToken: firebaseMessagingToken_1,
                            notificationPermission: permissionState,
                        },
                        description: description,
                    });
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); }, [dispatch, description]);
    var refreshToken = (0, react_1.useCallback)(function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var error_2;
        var _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!firebaseMessagingToken) return [3 /*break*/, 2];
                    dispatch({
                        type: 'SET_WINDOW_META',
                        values: {
                            firebaseMessagingToken: null,
                        },
                        description: description,
                    });
                    return [4 /*yield*/, submitRemovePushToken({ token: firebaseMessagingToken })];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2:
                    if (!(clientMeta_1.clientMeta.platform === 'AndroidNative' ||
                        clientMeta_1.clientMeta.platform === 'IosNative')) return [3 /*break*/, 3];
                    (_a = window.refreshMessagingToken) === null || _a === void 0 ? void 0 : _a.call(window);
                    return [3 /*break*/, 8];
                case 3:
                    _b.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, (0, messaging_1.deleteToken)((0, messaging_1.getMessaging)())];
                case 4:
                    _b.sent();
                    return [3 /*break*/, 6];
                case 5:
                    error_2 = _b.sent();
                    (0, sentrySdk_1.sentrySdk)().captureMessage("".concat(description, " - deleteToken: ").concat(JSON.stringify(error_2)), SentrySeverity_1.SentrySeverity.Warning);
                    return [3 /*break*/, 6];
                case 6: return [4 /*yield*/, setToken()];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    }); }, [firebaseMessagingToken, submitRemovePushToken, setToken]);
    return { setToken: setToken, refreshToken: refreshToken };
};
exports.useFirebaseMessaging = useFirebaseMessaging;
